export const getQuickInsertProviderMenuItemKey = (key: string): string =>
	`quick-insert-provider-${key}`;
